import { render } from "./CalculRationView.vue?vue&type=template&id=f0b99f70&scoped=true"
import script from "./CalculRationView.vue?vue&type=script&lang=js"
export * from "./CalculRationView.vue?vue&type=script&lang=js"

import "./CalculRationView.vue?vue&type=style&index=0&id=f0b99f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b99f70"]])

export default __exports__